import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    theme: {
        options: {
            /** Theme option label for dark mode */
            dark: string;
            /** Theme option label for light mode */
            light: string;
            /** Theme option label for following the system theme */
            auto: string;
        };
        /** Submenu group label for selecting a theme preference */
        preference: string;
    };
    density: {
        options: {
            /** Density option label for a compact UI layout */
            compact: string;
            /** Density option label for the default UI layout */
            regular: string;
            /** Density option label for a more spacious UI layout */
            spacious: string;
        };
        /** Submenu group label for selecting UI density */
        preference: string;
    };
    sizing: {
        options: {
            /** Sizing option label for small UI sizing */
            small: string;
            /** Sizing option label for the default UI sizing */
            regular: string;
            /** Sizing option label for large UI sizing */
            large: string;
        };
        /** Submenu group label for selecting UI sizing */
        preference: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            theme: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        options: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Theme option label for dark mode */
                                    dark: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.theme.options.dark?c=ua09gnie61c2", defaultMessage: "Dark" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Theme option label for light mode */
                                    light: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.theme.options.light?c=108yrin4thjgt", defaultMessage: "Light" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Theme option label for following the system theme */
                                    auto: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.theme.options.auto?c=20xn89qgrx2ln", defaultMessage: "System" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Submenu group label for selecting a theme preference */
                        preference: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.theme.preference?c=vuhgerm08hlq", defaultMessage: "Theme" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            density: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        options: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Density option label for a compact UI layout */
                                    compact: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.density.options.compact?c=sjyeqv0dn4tc", defaultMessage: "Compact" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Density option label for the default UI layout */
                                    regular: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.density.options.regular?c=urd08h68yy4t", defaultMessage: "Regular" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Density option label for a more spacious UI layout */
                                    spacious: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.density.options.spacious?c=2rsis30fzf3sv", defaultMessage: "Spacious" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Submenu group label for selecting UI density */
                        preference: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.density.preference?c=2foztbjxsjca6", defaultMessage: "Density" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            sizing: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        options: {
                            get() {
                                return Object.defineProperties({
                                    [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                                }, {
                                    /** Sizing option label for small UI sizing */
                                    small: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.sizing.options.small?c=20h83do0ozstd", defaultMessage: "Small" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Sizing option label for the default UI sizing */
                                    regular: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.sizing.options.regular?c=urd08h68yy4t", defaultMessage: "Regular" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    },
                                    /** Sizing option label for large UI sizing */
                                    large: {
                                        get() {
                                            return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.sizing.options.large?c=12ksa1sv7fvn4", defaultMessage: "Large" }));
                                        },
                                        enumerable: true,
                                        configurable: true
                                    }
                                });
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Submenu group label for selecting UI sizing */
                        preference: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppThemeSelectionMenuItem.sizing.preference?c=3pzwprllle7g8", defaultMessage: "Sizing" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
